import { type GridRenderEditCellParams } from "@mui/x-data-grid";
import { type FC } from "react";
import { type WorkPacket } from "src/types/work-packets";
import EditableAutocompleteCell from "../EditableAutocompleteCell";
import { deniedReasonOptions } from "src/pages/UserDashboard/Cases/api/constants";

export const DeniedReasonEdit: FC<GridRenderEditCellParams<WorkPacket>> = props => {
  return <EditableAutocompleteCell {...props} options={deniedReasonOptions} />;
};
